<template>
  <p :class="$style.chatMessageLivechat">{{ messageText }}</p>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { LivechatMessage, MatchUser } from '@/types/app'
import { captureException } from '@sentry/vue'

export default defineComponent({
  name: 'ChatMessageLivechat',
  props: {
    user: {
      type: Object as PropType<MatchUser>,
      required: true,
    },
    message: {
      type: Object as PropType<LivechatMessage>,
      required: true,
    },
  },
  computed: {
    messageText(): string {
      switch (this.message.status) {
        case 'planner_created':
          return `${this.user.nickname}さんに通話チャットの依頼を送信しました。`
        case 'planner_cancelled':
        case 'planner_closed':
          return `${this.user.nickname}さんとの通話チャットを終了しました。`
        case 'user_rejected':
          return `${this.user.nickname}さんが通話チャットをキャンセルしました。`
        default: {
          captureException(this.message.status)
          return '' // TODO: いいのか？
        }
      }
    },
  },
})
</script>

<style lang="scss" module>
.chatMessageLivechat {
  display: block;
  padding: 16px;
  background-color: $color-surface-tertiary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-24;
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  font-weight: bold;
  text-align: center;

  &:nth-child(n + 2) {
    margin-top: 40px;
  }
}
</style>
